import { createTheme } from '@mui/material/styles';

// One font for the whole app. Keep in sync with --font-family in styles/index.css
export const APP_FONT_FAMILY = '"Roboto", "Helvetica", "Arial", sans-serif';

const headingWeight = { fontWeight: 700 };

const theme = createTheme({
  typography: {
    fontFamily: APP_FONT_FAMILY,
    h1: headingWeight,
    h2: headingWeight,
    h3: headingWeight,
    h4: headingWeight,
    h5: headingWeight,
    h6: headingWeight,
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    // Buttons and tabs in sentence case, as on the facility screens
    button: { textTransform: 'none', fontWeight: 700 },
  },
});

export default theme;
